import { Fragment, useEffect } from "react";
import { IconButton, Tooltip } from "@material-ui/core";

import AddRoundedIcon from "@material-ui/icons/AddRounded";
import AdministrarEmpresa from "./AdministrarEmpresa";
import EditIcon from "@material-ui/icons/Edit";
import FormEmpresa from "./FormEmpresa";
import MeditocBody from "../../../utils/MeditocBody";
import MeditocHeader from "../../../utils/MeditocHeader";
import MeditocTable from "../../../utils/MeditocTable";
import RefreshIcon from "@material-ui/icons/Refresh";
import WorkRoundedIcon from "@material-ui/icons/WorkRounded";
import { fnEmpty } from "../../../../settings/preventConfig";
import { getEmpresaColumns } from "../../../../models/EmpresaModel";
import { useEmpresa } from "../../../../context/EmpresaContext";
import { useLogin } from "../../../../context/LoginContext";

export default function Empresa() {
    const {
        listaEmpresas,
        empresaSeleccionada,
        handleChangeEmpresaSeleccionada,
        handleClickNuevaEmpresa,
        handleClickEditarEmpresa,
        handleClickAdministrarEmpresa,
        handleClickRefrescarDatos,
    } = useEmpresa();
    const { usuarioPermisos } = useLogin();

    const permisos = usuarioPermisos["2"].Submodulos["2"];

    useEffect(() => {
        handleClickRefrescarDatos();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <MeditocHeader title={permisos.Nombre}>
                {permisos.Botones["1"] && ( //Nueva empresa
                    <Tooltip title={permisos.Botones["1"].Nombre} arrow>
                        <IconButton onClick={handleClickNuevaEmpresa}>
                            <AddRoundedIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["2"] && ( //Editar datos de empresa
                    <Tooltip title={permisos.Botones["2"].Nombre} arrow>
                        <IconButton onClick={handleClickEditarEmpresa}>
                            <EditIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["3"] && ( //Administrar folios de empresa
                    <Tooltip title={permisos.Botones["3"].Nombre} arrow>
                        <IconButton onClick={handleClickAdministrarEmpresa}>
                            <WorkRoundedIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["4"] && ( //Actualizar tabla
                    <Tooltip title={permisos.Botones["4"].Nombre} arrow>
                        <IconButton onClick={handleClickRefrescarDatos}>
                            <RefreshIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
            </MeditocHeader>
            <MeditocBody>
                <MeditocTable
                    columns={getEmpresaColumns()}
                    data={listaEmpresas}
                    row={empresaSeleccionada}
                    setRow={handleChangeEmpresaSeleccionada}
                    id="iIdEmpresa"
                    fnDoubleClick={permisos.Botones["3"] !== undefined ? handleClickAdministrarEmpresa : fnEmpty}
                />
            </MeditocBody>
            <FormEmpresa />
            <AdministrarEmpresa />
        </Fragment>
    );
}
